import { DEFAULT_FILTERS } from "../constants/constants";
import { PARAMS } from "../constants/typings";

export default class Helpers {
  static formatDate(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  static formatDateIntl(
    date: Date | string,
    locale: string = "en-US",
    options: Intl.DateTimeFormatOptions = {}
  ): string {
    let parsedDate: Date;

    if (typeof date === "string") {
      parsedDate = new Date(date);
    } else if (date instanceof Date) {
      parsedDate = date;
    } else {
      throw new Error("Invalid date input");
    }

    if (isNaN(parsedDate.getTime())) {
      throw new Error("Invalid Date");
    }

    const defaultOptions: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric"
    };

    const formatter = new Intl.DateTimeFormat(locale, { ...defaultOptions, ...options });
    return formatter.format(parsedDate);
  }


  static buildUrl(data: PARAMS) {
    const filteredObj = Object.fromEntries(
      Object.entries(data).filter(([key, value]) => {
        if (key === "start_date_from") return true;
        if (key === "submit") return false;
        if (DEFAULT_FILTERS[key] !== undefined && value === DEFAULT_FILTERS[key]) {
          return false;
        }
        return true;
      })
    );
    const queryString = Object.entries(filteredObj)
      .filter(([key, value]) => value !== null)
      .map(([key, value]) => `&q[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`)
      .join("");
    return queryString;
  }

  static isValidDate(dateString: string): boolean {
    // Define the date format you expect: mm-dd-YYYY
    const datePattern = /^\d{4}\-\d{2}\-\d{2}$/;

    // Check if the date string matches the expected format
    if (!dateString.match(datePattern)) {
      return false;
    }

    // Parse the date components
    const [year, month, day] = dateString.split("-").map(Number);

    // Create a Date object from the parsed components
    const date = new Date(year, month - 1, day);

    // Check if the date is valid (handles cases like 02.30.2023)
    if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
      return false;
    }

    // Get today's date
    const today = new Date();

    // Calculate the min and max dates (-5 years and +5 years from today)
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 1);

    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() + 2);

    // Check if the date is within the range
    return date >= minDate && date <= maxDate;
  }
}
